import {gql} from 'graphql-request';
import {useGqlRequest} from '@/api/request';
import {useQuery} from '@tanstack/react-query';
import {EstSalesTopRankItem, KodataCategoryGroup} from '../@types';

export const useTopSalesCategory = (variables?: {
  sggCodes: string[];
  categories: KodataCategoryGroup[];
}) => {
  const request = useGqlRequest({
    query: RANKING_EST_SALES_BY_ADM,
  });

  const queryFn = ():
    | undefined
    | Promise<{
        result?: EstSalesTopRankItem[];
      }> => {
    if (!variables) {
      return;
    }

    return request(variables);
  };

  const select = (data?: {result?: EstSalesTopRankItem[]}) => data?.result;

  return useQuery({
    queryFn,
    queryKey: ['ranking', 'top-sales', variables],
    enabled: !!variables,
    select,
  });
};

const RANKING_EST_SALES_BY_ADM = gql`
  query rankingBoardByHjd($categories: [Category!]!, $sggCodes: [String!]!) {
    result: rankingBoardByHjd(categories: $categories, sggCodes: $sggCodes) {
      averageEstSale
      category
      categoryDetail
      categoryGroup
      geometry {
        type
        coordinates
      }
      totalEstSales
    }
  }
`;
